import React from "react";
//assets
import indicatorPriorityItem from "img/icon-indicator-priority-item.svg";
import indicatorRecurringItem from "img/icon-indicator-recurrent-item.svg";
import indicatorRelevantItem from "img/icon-indicator-relevant-item.svg";
import indicatorWinningItem from "img/icon-indicator-winning-item.svg";
import OLColoredIcon from "img/icon-indicator-ol.svg";
import AutoAnswerColoredIcon from "img/AutoresponderIcon.svg";
import AnalyzedAutoAnswerIcon from "img/icon-indicator-autoanswer-read.svg";
import indicatorQuoteRead from "img/icon-indicator-quote-read.svg";
import indicatorQuoteUnread from "img/icon-indicator-quote-unread.svg";
import indicatorCloseToExpiring from "img/icon-indicator-close-to-expiring.svg"
//interfaces
import { IQuoteAnalyzed } from "models/QuoteBionexo";
import { IQuoteItemIndicators } from "./interface";
//styles
import { IconIndicators, Indicators, TooltipContainer, TooltipIndicator } from "./styles";

const QuoteItemIndicators: React.FC<IQuoteItemIndicators> = ({ data, saveQuotationViewed }) => {
  const iconQuoteRead = () => {
    return (
      <>
        <IconIndicators
          onClick={() => saveQuotationViewed()}
          role="img"
          data-testid="icon-quote-read"
          alt={data.isRead ? "Cotações lidas" : "Cotações não lidas"}
          className={data.isRead ? "element-child" : "special-child"}
          src={data.isRead ? indicatorQuoteRead : indicatorQuoteUnread}
        />
        <TooltipIndicator>
          {data.isRead ? "Cotações lidas" : "Cotações não lidas"}
        </TooltipIndicator>
      </>
    );
  };

  const iconAutoAnswer = () => {
    const analyzedItem = data?.quoteAnalyzed;
    const analized = analyzedItem?.map((item: IQuoteAnalyzed) => item.analyzed);
    const analizedItemUser = analyzedItem?.map((item: IQuoteAnalyzed) => item.username);
    const toolTipLabel = analyzedItem?.length > 0 ? analizedItemUser[0] : "Resposta Automática";
  
    if (data && (!analized || analized.length === 0)) {
      return (
        <>
          <IconIndicators className="element-child" src={AutoAnswerColoredIcon}></IconIndicators>
          <TooltipIndicator>Resposta Automática</TooltipIndicator>
        </>
      );
    } else {
      return (
        <>
          <IconIndicators className="element-child-offset" src={AnalyzedAutoAnswerIcon}></IconIndicators>
          <TooltipIndicator isRead={true}>{toolTipLabel}</TooltipIndicator>
        </>
      );
    }
  };
  
  return (
    <Indicators>
      {data?.hasItemOl && data?.quoteWithAutomaticItems && (
        <TooltipContainer>
          <IconIndicators className="element-child" src={OLColoredIcon} />
          <TooltipIndicator>Operação Logística</TooltipIndicator>
        </TooltipContainer>
      )}
      <TooltipContainer>{iconQuoteRead()}</TooltipContainer>
      {data.indicators?.winningItem && (
        <TooltipContainer>
          <IconIndicators className="element-child-offset" src={indicatorWinningItem} />
          <TooltipIndicator>Itens ganhos</TooltipIndicator>
        </TooltipContainer>
      )}
      {data?.quoteWithAutomaticItems && (
        <TooltipContainer>{iconAutoAnswer()}</TooltipContainer>
      )}
      {data.indicators?.relevantItem && (
        <TooltipContainer>
          <IconIndicators className="element-child" src={indicatorRelevantItem} />
          <TooltipIndicator>Itens relevantes</TooltipIndicator>
        </TooltipContainer>
      )}
      {data.indicators?.priorityItem && (
        <TooltipContainer>
          <IconIndicators className="special-child" src={indicatorPriorityItem} />
          <TooltipIndicator>SKU’s Prioritários</TooltipIndicator>
        </TooltipContainer>
      )}
      {data.indicators?.recurringItem && (
        <TooltipContainer>
          <IconIndicators className="element-child" src={indicatorRecurringItem} />
          <TooltipIndicator>Itens recorrentes</TooltipIndicator>
        </TooltipContainer>
      )}
      {data.indicators?.closeToExpiring && (
        <TooltipContainer>
          <IconIndicators className="special-child" src={indicatorCloseToExpiring} />
          <TooltipIndicator>Perto de Expirar</TooltipIndicator>
        </TooltipContainer>
      )}
    </Indicators>
  );
};

export default QuoteItemIndicators;
